export const propsPhraseMain = {
  frase: "¡Que la demanda de datos no te distraiga de tu actividad principal!",
};
